export function cookie(name) {
  const [_, value] = document.cookie.match(new RegExp(`(?:^|\\s)${name}=([^;]+)`)) || [];
  return value;
}